import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeQuote } from './redux/quoteSlice';
import loadingImg from './images/loading-img.gif';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Info from './components/Info/Info';
import Observations from './components/Observations/Observations';
import Payment from './components/Payment/Payment';
import PrintButton from './components/PrintButton/PrintButton';
import NotFound from './components/NotFound/NotFound';
import formatInfos from './helpers/formatInfos';
import Discount from './components/Discount/Discount';

function App() {
  const dispatch = useDispatch();
  const { accountId } = useSelector((state) => state.quote);
  const { pathname: subdomain } = window.location;
  const [willShow, setWillShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getInfos = async (pathname) => {
    const paths = pathname.split('/');
    const id = paths[1];
    const hash = paths[2];
    const linktype = paths[3];
    const endpoint = `${process.env.REACT_APP_DOMAIN_URL}/${process.env.REACT_APP_QUOTE_URL}/${id}?hash=${hash}`;

    setIsLoading(true);

    try {
      const response = await fetch(endpoint);
      const result = await response.json();
      if (
        result.status === 'error'
        || (paths.length !== 3
          && paths[3] !== '1'
          && paths[3] !== '2'
          && paths[3] !== '')
      ) {
        setWillShow(false);
      } else {
        dispatch(changeQuote(formatInfos(result, hash, linktype)));
        setWillShow(true);
      }
    } catch (e) {
      setIsLoading(false);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    getInfos(subdomain);
  }, []);

  if (isLoading) {
    return (
      <figure
        style={{ backgroundImage: `url(${loadingImg})` }}
        id="loading-image"
      />
    );
  }
  if (!willShow || accountId !== 2015) {
    return <NotFound />;
  }
  return (
    <>
      <PrintButton />
      <Header />
      <Info />
      <Discount />
      <Payment />
      <Observations />
      <Footer />
    </>
  );
}

export default App;
